<template>
  <Modal v-if="showModalInfoReservation" @close="closeModalInfoReservation">
    <div class="infoReservation">
      <div class="infoReservation__header">
        <span class="title">{{ $t('infoReservation') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="closeModalInfoReservation"
        />
      </div>
      <div class="infoReservation__body">
        <div class="info" v-if="activeReservations.phoneNumber">
          <p>{{ $t('mobilePhone') }}</p>
          <span>{{ activeReservations.phoneNumber }}</span>
        </div>
        <div class="info" v-if="activeReservations.deliveryStatus">
          <p>{{ $t('deliveryStatus') }}</p>
          <span>{{ $t(activeReservations.deliveryStatus) }}</span>
          <span v-if="activeReservations.deliveryStatus === 'expired'">
            ({{ $t(getDeliveryStatus()) }})
          </span>
        </div>
        <div class="info">
          <p>{{ $t('ssn') }}</p>
          <span>{{ getDataSSN() }}</span>
          <Button
            v-if="!isSSN"
            class="ssn_btn"
            variant="notBordered"
            :title="$t('show')"
            @click="showSsn"
          />
        </div>
        <div class="info" v-if="activeReservations.expiredTime">
          <p>{{ $t('timeExpired') }}</p>
          <span>{{ dateTime(activeReservations.expiredTime) }}</span>
        </div>
        <div class="info" v-if="activeReservations.deliveryId">
          <p>{{ $t('kolliID') }}</p>
          <span>
            {{
              getIds(
                activeReservations.deliveryId,
                activeReservations.additionalDeliveryIds
              )
            }}
          </span>
        </div>
        <div class="info" v-if="activeReservations.fulfillment_order_id">
          <p>{{ $t('fulfillment_order_id') }}</p>
          <span>{{ activeReservations.fulfillment_order_id }}</span>
        </div>
        <div class="info" v-if="activeReservations.is_drug">
          <p>{{ $t('includesDrug') }}</p>
          <span>{{ getIsDrud(activeReservations.is_drug) }}</span>
        </div>
        <div
          class="info"
          v-if="activeReservations.lockerId || activeReservations?.shelf"
        >
          <p>{{ $t('lockerID') }}</p>
          <span>{{ getLockerIdOrShelf(activeReservations) }}</span>
        </div>
        <div class="info" v-if="activeReservations.order_id">
          <p>{{ $t('order_id') }}</p>
          <span>{{ activeReservations.order_id }}</span>
        </div>
        <div
          class="info"
          v-if="
            activeReservations.deliveryTime ||
            activeReservations.deliveryUserName
          "
        >
          <p>{{ $t('delivered') }}</p>
          <span>
            {{ activeReservations.deliveryUserName }}
            {{ dateTime(activeReservations.deliveryTime) }}
          </span>
        </div>
        <div
          class="info"
          v-if="
            activeReservations.deleteTime || activeReservations.deleteUserName
          "
        >
          <p>{{ $t('deleted') }}</p>
          <span>
            {{ activeReservations.deleteUserName }}
            {{ dateTime(activeReservations.deleteTime) }}
          </span>
        </div>
        <div
          class="info"
          v-if="
            activeReservations.reservedUserId || activeReservations.reservedTime
          "
        >
          <p>{{ $t('reserved') }}</p>
          <span>
            {{
              activeReservations.reservedUserId === 'API'
                ? activeReservations.reservedUserId
                : activeReservations.reservedUserName
            }}
            {{ dateTime(activeReservations.reservedTime) }}
          </span>
        </div>
        <div
          class="info"
          v-if="
            activeReservations.assignedUserName ||
            activeReservations.assignedTime
          "
        >
          <p>{{ $t('assignedUserName') }}</p>
          <span>
            {{ activeReservations.assignedUserName }}
            {{ dateTime(activeReservations.assignedTime) }}
          </span>
        </div>
        <div
          class="info"
          v-if="
            activeReservations.removedUserName || activeReservations.removedTime
          "
        >
          <p>{{ $t('removed') }}</p>
          <span>
            {{ activeReservations.removedUserName }}
            {{ dateTime(activeReservations.removedTime) }}
          </span>
        </div>
        <div class="info" v-if="activeReservations.resendSMSCounter">
          <p>{{ $t('resendSMSCounter') }}</p>
          <span>{{ activeReservations.resendSMSCounter }}</span>
        </div>
        <div class="info" v-if="activeReservations.resendSMSTimestamps">
          <p>{{ $t('resendSMSTimestamps') }}</p>
          <span>{{ dateTime(isLastTime) }}</span>
        </div>
      </div>
      <div class="infoReservation__buttons">
        <Button
          variant="bordered"
          :title="$t('cancel')"
          @click="closeModalInfoReservation"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import moment from 'moment';
import { DataReservations } from '@/store/modules/pharmacy/types';

@Options({
  name: 'InfoReservation',
  emits: ['getDecodedSsn', 'closeModal'],
  props: ['showModalInfoReservation', 'activeReservations', 'showDecodedSsn'],
  data() {
    return {
      isSSN: false
    };
  },
  computed: {
    isLastTime() {
      return this.activeReservations.resendSMSTimestamps[
        this.activeReservations.resendSMSTimestamps.length - 1
      ].sendTime;
    }
  },

  methods: {
    dateTime(value: string) {
      return moment(value).format('DD.MM.YYYY HH:mm');
    },
    getIds(deliveryId: string, additionalDeliveryIds: Array<string>) {
      if (!additionalDeliveryIds[0] && !additionalDeliveryIds[1]) {
        return deliveryId;
      } else if (additionalDeliveryIds[1] !== '') {
        return deliveryId + ', ' + additionalDeliveryIds.join(', ');
      } else if (additionalDeliveryIds[1] === '') {
        return deliveryId + ', ' + additionalDeliveryIds.join('');
      }
    },
    getDeliveryStatus() {
      if (
        this.activeReservations.deliveryStatus === 'expired' &&
        !this.activeReservations.deliveryTime
      ) {
        return 'reservation';
      } else if (
        this.activeReservations.deliveryStatus === 'expired' &&
        this.activeReservations.deliveryTime
      ) {
        return 'delivery';
      } else {
        return '';
      }
    },
    getLockerId(item: Array<string>) {
      return item?.join(', ');
    },
    getLockerIdOrShelf(data: DataReservations) {
      if (data?.shelf) {
        return data?.shelf
          .map((item: string) =>
            item === 'cooling' ? this.$t('cooling') : item.toUpperCase()
          )
          .join(', ');
      } else {
        return this.getLockerId(data?.lockerId);
      }
    },
    getIsDrud(value: boolean) {
      return value ? `${this.$t('yes')}` : `${this.$t('no')}`;
    },
    getDataSSN() {
      if (this.isSSN) {
        return this.showDecodedSsn.length
          ? this.showDecodedSsn
          : this.$t('noSsn');
      } else {
        return '************';
      }
    },
    showSsn() {
      this.$emit('getDecodedSsn', this.activeReservations.deliveryId);
      this.isSSN = true;
    },
    closeModalInfoReservation() {
      this.isSSN = false;
      this.$emit('closeModal');
    }
  }
})
export default class InfoReservation extends Vue {}
</script>

<style lang="scss" scoped>
.infoReservation {
  max-width: 700px;
  height: 100%;
  padding: 24px;
  .infoReservation__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .infoReservation__body {
    width: 283px;
    height: 275px;
    padding: 16px;
    background-color: $light-grey;
    border: 1px solid $border;
    border-radius: 8px;
    overflow-y: scroll;
    margin-bottom: 23px;

    .info {
      margin-bottom: 25px;
      background-color: $light-grey;
      p {
        color: $label;
        line-height: 14px;
        font-size: $twelveSize;
        background-color: $light-grey;
      }
      span {
        color: $mid-grey;
        line-height: 14px;
        font-size: $fourteenSize;
        background-color: $light-grey;
      }
      .ssn_btn {
        width: 0;
        height: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
